import React from 'react';
import { Link } from 'gatsby';
import withStyles from '@material-ui/core/styles/withStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Button from '@material-ui/core/Button';
import CustomDropdown from '../CustomDropdown/CustomDropdown';
import headerLinksStyle from 'assets/jss/material-kit-react/components/headerLinksStyle.jsx';

function HeaderLinks({ ...props }) {
  const { classes } = props;
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <Link
          to='/locations/'
          className={classes.customLink}
          activeClassName='active'
        >
          <Button className={classes.navLink}>Locations</Button>
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link
          to='/booking/'
          className={classes.customLink}
          activeClassName='active'
        >
          <Button className={classes.navLink}>Booking</Button>
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          buttonText='Cleaning Services'
          buttonProps={{
            className: classes.navLink,
            color: 'transparent',
          }}
          dropdownList={['Domestic', { divider: true }, 'Commercial/Office ']}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to='/faq' className={classes.customLink} activeClassName='active'>
          <Button className={classes.navLink}>Faq</Button>
        </Link>
      </ListItem>
    </List>
  );
}

export default withStyles(headerLinksStyle)(HeaderLinks);
